import { makeStyles } from '@mui/styles';

const styles = makeStyles({
	containerClass: {
		marginTop: 80,
		marginBottom: 15,
		paddingTop: '0px',
		paddingBottom: '0px',
		paddingLeft: '0px',
		paddingRight: '0px',
		borderRadius: 10,
		backgroundColor: 'rgb(255, 255, 255)',
		boxShadow:
			'rgba(0, 0, 0, 0.06) 0px 3px 3px -2px, rgba(0, 0, 0, 0.04) 0px 3px 4px 0px, rgba(0, 0, 0, 0.04) 0px 1px 8px 0px !important',
	},
	contentContainer: {
		margin: 15,
	},
	titleContainer: {
		padding: 15,
		fontSize: 32,
		background:
			'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(25,118,210,1) 35%, rgba(0,212,255,1) 100%)',
		color: 'white',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		height: 60,
	},
	textContainer: {
		textAlign: 'justify',
		marginTop: 30,
	},
	mainContent: {
		marginTop: 20,
	},
	titleText: {
		color: '#1976d2',
		fontWeight: 'bolder',
		marginTop: 15,
		marginBottom: 15,
	},
	listClass: {
		gap: 10,
		display: 'flex',
		flexDirection: 'column',
		color: 'lightslategray',
	},
	orderedListContainer: {
		paddingLeft: 40,
	},
	mainOrderedListContainer: {
		listStyle: 'none',
		paddingLeft: 0,
	},
	childList: {
		fontWeight: 'normal',
		marginTop: 10,
	},
	childText: {
		paddingLeft: 20,
		fontWeight: 'normal',
	},
});

export default styles;
